import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar.tsx";
import Header from "./Header.tsx";
import { GoBack } from "../components/GoBack.js";
import { useLocation } from "react-router-dom";

export default function DashboardLayout({
  pageTitle: initialPageTitle,
  children,
}) {
  const [pageTitle, setPageTitle] = useState(initialPageTitle);
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const isNestedRoute = () => {
    const pathSegments = location.pathname
      .split("/")
      .filter((segment) => segment);
    return pathSegments.length > 1;
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); // Runs whenever the route changes

  return (
    <>
      <Header pageTitle={pageTitle} toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <main className="layout__body">
        {isNestedRoute() && <GoBack />}
        {React.cloneElement(children, { setPageTitle })}
      </main>
    </>
  );
}
